import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { NbIconLibraries } from "@nebular/theme";
import { DomSanitizer } from "@angular/platform-browser";
import { lastValueFrom } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class IconService {
  constructor(
    private iconLibraries: NbIconLibraries,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
  ) {}

  public registerIcons(): Promise<void> {
    const icons = [
      { name: "q-resultats", url: "assets/icons/q-ico-resultats.svg" },
      { name: "q-loupe", url: "assets/icons/q-ico-loupe.svg" },
      { name: "q-options", url: "assets/icons/q-ico-options.svg" },
      { name: "q-accueil", url: "assets/icons/q-ico-accueil.svg" },
      { name: "q-alertes", url: "assets/icons/q-ico-alertes.svg" },
      { name: "q-elevage-bovin", url: "assets/icons/q-ico-elevage-bovin.svg" },
      { name: "q-elevage-ovin", url: "assets/icons/q-ico-elevage-ovin.svg" },
      { name: "q-elevage-caprin", url: "assets/icons/q-ico-elevage-caprin.svg" },
      { name: "q-elevage-equin", url: "assets/icons/q-ico-elevage-equin.svg" },
      { name: "q-logout", url: "assets/icons/q-ico-logout.svg" },
      { name: "q-fleche-droite", url: "assets/icons/q-ico-fleche-droite.svg" },
      { name: "q-imprimer", url: "assets/icons/q-ico-imprimer.svg" },
      { name: "q-partager", url: "assets/icons/q-ico-partager.svg" },
      { name: "q-telecharger", url: "assets/icons/q-ico-telecharger.svg" },
      { name: "q-ajout-lot-bovin", url: "assets/icons/q-ico-ajout-lot-bovin.svg" },
      { name: "q-ajout-lot-ovin", url: "assets/icons/q-ico-ajout-lot-ovin.svg" },
      { name: "q-ajout-lot-caprin", url: "assets/icons/q-ico-ajout-lot-caprin.svg" },
      { name: "q-ajout-lot-equin", url: "assets/icons/q-ico-ajout-lot-equin.svg" },
      { name: "q-creer-lot", url: "assets/icons/q-ico-creer-lot.svg" },
      { name: "q-retirer-lot", url: "assets/icons/q-ico-retirer-lot.svg" },
      { name: "q-quitter", url: "assets/icons/q-ico-quitter.svg" },
      { name: "q-courbe", url: "assets/icons/q-ico-courbe.svg" },
      { name: "q-supprimer", url: "assets/icons/q-ico-supprimer.svg" },
      { name: "q-modifier", url: "assets/icons/q-ico-modifier.svg" },
      { name: "q-password", url: "assets/icons/q-ico-password.svg" },
      { name: "q-utilisateur", url: "assets/icons/q-ico-utilisateur.svg" },
      { name: "q-utilisateurs", url: "assets/icons/q-ico-utilisateurs.svg" },
      { name: "q-phone", url: "assets/icons/q-ico-phone.svg" },
      { name: "q-import", url: "assets/icons/q-ico-import.svg" },
      { name: "q-ajout-utilisateur", url: "assets/icons/q-ico-ajout-utilisateur.svg" },
      { name: "q-fermer", url: "assets/icons/q-ico-fermer.svg" },
      { name: "q-croissance", url: "assets/icons/q-ico-croissance.svg" },
      { name: "q-voir", url: "assets/icons/q-ico-voir.svg" },
      { name: "q-csv", url: "assets/icons/q-ico-csv.svg" },
      { name: "q-societe", url: "assets/icons/q-ico-societe.svg" },
      { name: "q-pause", url: "assets/icons/q-ico-pause.svg" },
      { name: "q-play", url: "assets/icons/q-ico-play.svg" },
      { name: "q-pltf-bovin-on", url: "assets/icons/q-ico-pltf-bovin-actif.svg" },
      { name: "q-pltf-bovin-hover", url: "assets/icons/q-ico-pltf-bovin-hover.svg" },
      { name: "q-pltf-bovin-off", url: "assets/icons/q-ico-pltf-bovin-inactif.svg" },
      { name: "q-pltf-caprin-on", url: "assets/icons/q-ico-pltf-caprin-actif.svg" },
      { name: "q-pltf-caprin-hover", url: "assets/icons/q-ico-pltf-caprin-hover.svg" },
      { name: "q-pltf-caprin-off", url: "assets/icons/q-ico-pltf-caprin-inactif.svg" },
      { name: "q-pltf-ovin-on", url: "assets/icons/q-ico-pltf-ovin-actif.svg" },
      { name: "q-pltf-ovin-hover", url: "assets/icons/q-ico-pltf-ovin-hover.svg" },
      { name: "q-pltf-ovin-off", url: "assets/icons/q-ico-pltf-ovin-inactif.svg" },
      { name: "q-pltf-equin-on", url: "assets/icons/q-ico-pltf-equin-actif.svg" },
      { name: "q-pltf-equin-hover", url: "assets/icons/q-ico-pltf-equin-hover.svg" },
      { name: "q-pltf-equin-off", url: "assets/icons/q-ico-pltf-equin-inactif.svg" },
      { name: "q-change-expl", url: "assets/icons/q-ico-change-exploitation.svg" },
      { name: "q-def-info-naissance", url: "assets/icons/q-ico-info-naissance.svg" },
    ];

    const iconPromises = icons.map((icon) => this.loadSvgIcon(icon.name, icon.url));

    return Promise.all(iconPromises).then((iconsData) => {
      const svgPack: { [key: string]: string } = iconsData.reduce(
        (pack, iconData) => {
          pack[iconData.name] = iconData.svg;
          return pack;
        },
        {} as { [key: string]: string },
      );
      this.iconLibraries.registerSvgPack("custom", svgPack);
    });
  }

  private async loadSvgIcon(name: string, url: string): Promise<{ name: string; svg: string }> {
    try {
      const svg = await lastValueFrom(this.http.get(url, { responseType: "text" }));
      return { name, svg };
    } catch (error) {
      console.error(`Erreur lors du chargement de l'icône ${name} depuis ${url}`, error);
      throw error;
    }
  }
}
